import React from 'react';
import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";
import AboutUs from '../AboutUs';
import Booking from '../Booking';
import ContactUs from '../ContactUs';
import HomePage from '../Home';
import Reviews from '../Reviews';
import SightSeeing from '../SeightSeeing/SightSeeing';
import StanstedAirport from '../StanstedAirport';
import Vehicles from '../Vehicles';
import Error from '../ErrorPage/Error';
import PrivacyPolicy from '../PrivacyPolicy';
import RefundPolicy from '../RefundPolicy';
import CookiePolicy from '../CookiePolicy';
import Payment from '../Payment';
import SingleSight from '../SeightSeeing/SingleSight';
import Flitwick from '../Flitwick';
import MyProfile from '../MyProfile';
import Faqs from '../Faqs';
import OurFleet from '../OurFleet';
import SingleFleet from '../SingleFleet';
import BookingHistory from '../../Components/Profile/BookingHistroy';
import SingleBookingDetails from '../../Components/Profile/SingleBookingDetail';
import EditProfile from '../../Components/Profile/EditProfile';
import ChangePassword from '../../Components/Profile/changePassword';
import JoinUs from '../JoinUs';


const AllRoute = () => {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/aboutus" element={<AboutUs />} />
          <Route path="/booking" element={<Booking />} />
          <Route path="/bookinghistroy" element={<BookingHistory />} />
          <Route path="/contactus" element={<ContactUs />} />
          <Route path="/changepassword" element={<ChangePassword />} />
          {/* <Route path="/reviews" element={<Reviews />} /> */}    
          <Route path="/joinus" element={<JoinUs />} />
          <Route path="/sightseeing" element={<SightSeeing />} />
          <Route path="/singlesight" element={<SingleSight />} />
          <Route path="/stanstedairport" element={<StanstedAirport />} />
          <Route path="/vehicles" element={<Vehicles />} />
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />
          <Route path="/refundpolicy" element={<RefundPolicy />} />
          <Route path="/cookiepolicy" element={<CookiePolicy />} />
          <Route path="/booking" element={<Booking />} />
          <Route path="/ourfleet" element={<OurFleet />} />
          <Route path="/payment" element={<Payment />} />
          <Route path="/faqs" element={<Faqs />} />
          <Route path="/flitwick" element={<Flitwick />} />
          <Route path="/singlefleet" element={<SingleFleet />} />
          <Route path="/singleBookingdetail" element={<SingleBookingDetails />} />
          <Route path="/myprofile" element={<MyProfile />} />
          <Route path="/editprofile" element={<EditProfile />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
      </BrowserRouter>
    </div>
  )
}

export default AllRoute;